<template>
    <v-dialog  persistent  v-model="dialog" width="500px">      
      <v-card >
        <v-card-title :class="`white--text ${typeColorType}`" >
            <label><h3>Dossier item</h3></label>
            <v-spacer></v-spacer>            
            <v-icon dark class="fas fa-times" style="color:#fff" @click="closeClicked()"></v-icon>      
        </v-card-title>       
        <v-card-text class="grey lighten-4"  >
            <v-layout   class="layout px-0 py-0" wrap row>                
                <v-flex sm6>
                    <div class="text-xs-center">
                        <h5>Type</h5>
                        <h4>{{dossierItem.itemType.name}}</h4>
                    </div>
                </v-flex>
                <v-flex sm6>
                    <div class="text-xs-center">                        
                        <div class="heade-date">{{dossierItem.timestamp | date_nl}}</div>
                        <div class="header-time">{{dossierItem.timestamp | time}}</div>
                    </div>
                </v-flex>            
            </v-layout>                        
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <v-tabs v-model="selectedTab" grow>
                <v-tab key="general">Algemeen</v-tab>
                <v-tab key="images" :disabled="!hasImages">Afbeeldingen</v-tab>
                <v-tab key="attachments"  :disabled="!hasAttachments">Bijlagen</v-tab>
            </v-tabs>                    
            <v-tabs-items v-model="selectedTab">   
                <v-tab-item key="general">     
                    <v-layout class="layout px-2 py-0" wrap row align-center pa-2>                
                        <v-flex sm12 align-center v-if="dossierItem.title" pa-2>
                            <h5 class="grey--text">Titel:</h5>{{dossierItem.title}}
                        </v-flex>
                        <v-flex sm12 align-center  v-if="dossierItem.text" pa-2>
                            <h5 class="grey--text">Bericht:</h5>{{dossierItem.text}}
                        </v-flex>                      
                    </v-layout>
                </v-tab-item>
                <v-tab-item key="images">  
                    <v-flex sm12 align-center  v-if="dossierItem.images && dossierItem.images.length>0">
                        <v-layout>
                            <v-carousel height="340" :hide-delimiters="true">
                                <v-tooltip bottom>                                            
                                <v-carousel-item              
                                    slot="activator"                      
                                    v-for="(item,i) in images"
                                    :key="i"
                                    :src="item.src"
                                    @click="openNewInNewTab(item.src)"                                    
                                ></v-carousel-item>
                            <span>Klik om volledige grote te openen in nieuw tabblad</span>
                            </v-tooltip>                                                            
                            </v-carousel>
                        </v-layout>                        
                    </v-flex>                    
                </v-tab-item>                
                <v-tab-item key="attachments">  
                     attachment
                </v-tab-item>                  
            </v-tabs-items>              
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-btn color="darken-1" flat @click="$emit('closeClicked')">Sluiten</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>

import { mapGetters } from 'vuex'
import * as types from "../../store/types"
import ColorMixin from "../../plugins/mixins/ColorMixin"

export default{    
    props:['dossierItem', 'asset'],
    mixins: [ColorMixin],
    data(){
        return {
            dialog: true,
            comments: '',
            selectedTab:0
        }
    },
    computed:{
        hasImages(){
            return !this.dossierItem.images || this.dossierItem.images.length == 0 ? false : true
        },
        images(){
            if(!this.hasImages)
                return []

            let arr = []
            this.dossierItem.images.forEach((image) => {
                arr.push({"title":image.title, "src":image.url})
            })                
            return arr
        },
        hasAttachments(){
            return false
        },
        severityColor(){
              switch(this.event.eventSeverity.internalName) {
                case 'irrelevant':
                    return "grey"
                case 'low':
                    return "grey";
                case 'average':
                    return "orange";
                case 'high':
                    return "red";
                case 'critical':
                    return "red";
                default :
                return 'grey';
            }
        },
        event(){
            return this.dossierItem.event
        },
        isEvent(){
            return this.itemType.internalName == "event" ? true : false
        },
        typeColorType(){            
            switch(this.dossierItem.messageType) {
                case 'success':
                    return "success"
                case 'error':
                    return "error";
                case 'info':
                    return "info";
                case 'warning':
                    return "warning";
                default :
                return 'grey';
            }
        },
        discarded(){
            return (this.dossierItem.data && this.dossierItem.data.discardedAt) ? true : false
                
        },
         discardable(){      

            if(this.event.eventType.internalName == 'error'){
                if(this.event.eventSeverity.priority >= 3){
                    return true
                }                
            }
            if(this.event.eventType.internalName == 'warning'){
                if(this.event.eventSeverity.priority >= 5){
                    return true
                }
            }
            },
    },
    methods:{        
        discardEvent(){
            let vm = this
            this.$store.dispatch(types.DISCARD_PROCESSED_EVENT, { data: { id: this.dossierItem.id }}).then(() => {                
                vm.$notify("Event afgehandeld", {type: 'success', icon: 'check'})
                vm.$emit("EventDiscarded")
            })
        },
        closeClicked(){
            this.$emit("closeClicked")
        },
        openNewInNewTab(src){
            window.open(src)
        }
    },

    mounted(){
    }
}
</script>

<style >
.header-time{
    font-size:24px;
    
}
.header-date{

}
.dossier-item-image img{
    margin:4px;
    width:150px;
    height:150px;
    border:2px solid #fff;
}

.dossier-item-image img:hover{
    border:4px solid #FF6C3D;
}

</style>